module.exports = __webpack_public_path__ + "img/xl.df831b3e.png";